// Product names like "AXIS SESSION (Semax-10)" or "Retatrutide 10mg" truncate
// on small screens and hide what distinguishes the product (peptide, dosage).
// Split the parenthetical OR the trailing strength onto its own gold badge
// line wherever a product title shows.
const BADGE_CLS =
  "inline-block mt-0.5 text-xs font-mono font-semibold tracking-wide px-2 py-0.5 bg-[#fbf6e7] text-[#8a6a1c] border border-[#c9a24a]/60 rounded-md";

export const splitProductName = (name) => {
  const n = name || "";
  const paren = n.match(/^(.*\S)\s*\((.+)\)\s*$/);
  if (paren && paren[1]) return { title: paren[1], badge: paren[2] };
  // Trailing strength: "10mg", "10/10mg", "500mcg", "10iu", "1.5ml"...
  const dose = n.match(/^(.+?)\s+(\d+(?:[./]\d+)*\s?(?:mg|mcg|g|iu|ml)(?:\/\w+)?)\s*$/i);
  if (dose && dose[1]) return { title: dose[1], badge: dose[2] };
  return { title: n, badge: null };
};

export const ProductTitle = ({ name, id, as: Tag = "h3", className = "font-semibold text-xl truncate" }) => {
  const { title, badge } = splitProductName(name);
  if (!badge) return <Tag className={className}>{title}</Tag>;
  return (
    <div className="min-w-0">
      <Tag className={className}>{title}</Tag>
      <span className={BADGE_CLS} data-testid={id ? `product-peptide-${id}` : undefined}>
        {badge}
      </span>
    </div>
  );
};
